// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa240.stage.monatest.icu/auto-open-api-spec.yaml 1.6.65
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializes Lab Value Types from database.
 * @see #/components/schemas/LabValueType - reference to schema in open-api-spec.yaml
 * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
 * @version 1.6.65
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface LabValueType {
    readonly code: string;
    readonly display_name: string;
    readonly type: string;
    /**
     * The unit for the lab value type
     *
     */
    unit?: string | null;
    readonly high: number;
    readonly low: number;
    /**
     * The visibility for the Lab Value Type.
     *
     */
    is_visible?: boolean;
    /**
     * Whether Lab Value Type is automated.
     *
     */
    readonly is_automated: boolean;
    /**
     * Whether Lab Value Type is a ABG Type.
     *
     */
    is_abg?: boolean;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for LabValueType
 */
export namespace LabValueType {
    /**
     * LabValueType Frontend Model with camelCase properties
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        readonly code: string;
        readonly displayName: string;
        readonly type: string;
        /**
         * The unit for the lab value type
         * @type string (`dataFormat` is missing)
         */
        unit?: string | null;
        readonly high: number;
        readonly low: number;
        /**
         * The visibility for the Lab Value Type.
         * @type boolean (`dataFormat` is missing)
         */
        isVisible?: boolean;
        /**
         * Whether Lab Value Type is automated.
         * @type boolean (`dataFormat` is missing)
         */
        readonly isAutomated: boolean;
        /**
         * Whether Lab Value Type is a ABG Type.
         * @type boolean (`dataFormat` is missing)
         */
        isAbg?: boolean;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * LabValueType DTO
     * Transforms LabValueType model from/to API object
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend LabValueType model */
        static toModel(obj: LabValueType): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend LabValueType model */
        static toApi(obj: Model): LabValueType {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as LabValueType;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
